import SettingsEthernetIcon from "@mui/icons-material/SettingsEthernet";
import TuneIcon from "@mui/icons-material/Tune";
import BannerIcon from "@mui/icons-material/ViewCarousel";
import SpeedDial from "@mui/lab/SpeedDial";
import SpeedDialAction from "@mui/lab/SpeedDialAction";
import SpeedDialIcon from "@mui/lab/SpeedDialIcon";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { OPEN_SETTING_DIALOG, OPEN_SETTING_LINKS_DIALOG } from "../../types";
import "./style.css";

const actions = [
  { icon: <TuneIcon />, name: "تنظیمات", op: "StickySetting" },
  { icon: <SettingsEthernetIcon />, name: "لینک ها", op: "DomainLinks" },
  { icon: <BannerIcon />, name: "بنر هدر", op: "HeaderBanner" },
];

export default function SpeedDials() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const handleClick = (op) => {
    switch (op) {
      case "StickySetting":
        dispatch({ type: OPEN_SETTING_DIALOG, payload: true });
        break;
      case "DomainLinks":
        dispatch({ type: OPEN_SETTING_LINKS_DIALOG, payload: true });
        break;
      case "HeaderBanner":
        navigate("/header-banner");
        break;
      default:
        break;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <SpeedDial
      FabProps={{ color: "secondary", size: "small" }}
      style={{ bottom: "10px", width: "20px", right: "15px", zIndex: 0 }}
      className="speed-dial"
      ariaLabel="SpeedDial example"
      icon={<SpeedDialIcon color={"secondary"} />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction={"up"}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => handleClick(action.op)}
        />
      ))}
    </SpeedDial>
  );
}
